import _ from 'lodash';
import { UseGridOperations } from '../../hooks/useGridOperations';
import { ReturnTypeofSheetSectionsSelector } from '../../selectors/sheetUiSelector';
import { Area, GridEntity, SelectionCell } from '../../types';
import { IconType } from 'react-icons';
import { BiCopy, BiCut, BiPaste, BiText } from 'react-icons/bi';
import { t } from 'i18next';
import { UseSheetTheme } from '../../hooks/useSheetTheme';
import { RxValueNone } from 'react-icons/rx';
import { AiOutlineClear, AiOutlineFormatPainter } from 'react-icons/ai';
import { TbMathFunction } from 'react-icons/tb';
import { MdFormatClear } from 'react-icons/md';
import { AppDispatch } from '../../../core/redux/store';
import { IContextMenuItem } from './types';
import { getCommonEntityMenu } from './commonEntityMenu';
import { getGroupMenu } from './groupMenu';
import { getCellMenu } from './cellMenu';
// import { Freeze } from 'react-icons/tb';

export interface GridContextMenuProps
  extends ReturnTypeofSheetSectionsSelector,
    Pick<
      UseGridOperations,
      | 'contextMenuState'
      | 'menuState'
      | 'closeContextMenu'
      // | 'performGridOperation'
      // | 'performCellOperation'
    >,
    Pick<UseSheetTheme, 'fill' | 'textColor'> {
  sheetId: string;
}

export const prepareContextMenu = (
  props: GridContextMenuProps,
  dispatch: AppDispatch
): IContextMenuItem[][] => {
  const { contextMenuState } = props;
  const { group, entityType } = contextMenuState;
  if (group && entityType) {
    // Create Menu For Group
    const groupMenus = getGroupMenu(
      group,
      entityType,
      parentLangKey,
      props,
      // props.performGridOperation
    );

    return [groupMenus];
  } else {
    // Create Menu based on active selection
    const lastSelection = _.last(props.selections);
    if (lastSelection) {
      const area = lastSelection.area;
      const cellType = lastSelection.cell;

      return createGridContextMenu(area, cellType, props, dispatch);
    }
  }

  return [];
};

const createMenuItem = (
  title: string,
  action?: () => void,
  Icon?: IconType,
  nestedMenus?: IContextMenuItem[][],
  titleParams?: Object,
  disabled?: boolean
): IContextMenuItem => ({
  title: t(`${parentLangKey}.${title}`, titleParams ?? {}),
  Icon,
  action,
  nestedMenus,
  disabled,
});

const createGridContextMenu = (
  area: Area,
  cellType: SelectionCell,
  props: GridContextMenuProps,
  dispatch: AppDispatch
) => {
  const menuSets = [commonMenu(area)]; // props.performCellOperation
  switch (cellType) {
    case SelectionCell.Column:
      const colBasicMenu = getCommonEntityMenu({
        area,
        entityName: GridEntity.Column,
        props,
        parentLangKey,
        // performGridOperation: props.performGridOperation,
        // performCellOperation: props.performCellOperation,
        dispatch
      });
      menuSets.push(colBasicMenu);
      break;
    case SelectionCell.Row:
      const rowBasicMenu = getCommonEntityMenu({
        area,
        entityName: GridEntity.Row,
        props,
        parentLangKey,
        // performGridOperation: props.performGridOperation,
        // performCellOperation: props.performCellOperation,
        dispatch
      });
      menuSets.push(rowBasicMenu);
      break;
    case SelectionCell.Cell:
      const cellMenu = getCellMenu({
        ...props,
        area,
        parentLangKey,
      });
      menuSets.push(cellMenu);
      break;
  }

  return menuSets;
};

// #region Common Menu

const parentLangKey = 'context-menu';
const commonMenu = (
  // performCellOperation: UseGridOperations['performCellOperation'],
  area: Area
): IContextMenuItem[] => [
  createMenuItem('cut', () => console.log('cut'), BiCut),
  createMenuItem('copy', () => console.log('copy'), BiCopy),
  createMenuItem(
    'paste',
    () => console.log('paste'),
    BiPaste,
    pasteNestedMenu()
  ),
  createMenuItem(
    'clear',
    () => console.log('clear'),
    RxValueNone,
    clearNestedMenu(area) //performCellOperation,
  ),
];

const pasteSpecialKey = 'paste_special';
const pasteNestedMenu = (): IContextMenuItem[][] => [
  [createMenuItem(`${pasteSpecialKey}.all`, () => {}, BiPaste)],
  [
    createMenuItem(`${pasteSpecialKey}.values`, () => {}, BiText),
    createMenuItem(
      `${pasteSpecialKey}.format`,
      () => {},
      AiOutlineFormatPainter
    ),
    createMenuItem(`${pasteSpecialKey}.formulas`, () => {}, TbMathFunction),
  ],
];

const clearLangKey = 'clear_special';
const clearNestedMenu = (
  // performCellOperation: UseGridOperations['performCellOperation'],
  area: Area
): IContextMenuItem[][] => [
  [
    createMenuItem(
      `${clearLangKey}.all`,
      () => {},
        // performCellOperation({
        //   op: CellOperations.ClearCells,
        //   source: area,
        //   clearType: CellClearType.All,
        // }),
      RxValueNone
    ),
  ],
  [
    createMenuItem(
      `${clearLangKey}.contents`,
      () => {},
        // performCellOperation({
        //   op: CellOperations.ClearCells,
        //   source: area,
        //   clearType: CellClearType.Contents,
        // }),
      MdFormatClear
    ),
    createMenuItem(
      `${clearLangKey}.formats`,
      () => {},
        // performCellOperation({
        //   op: CellOperations.ClearCells,
        //   source: area,
        //   clearType: CellClearType.Format,
        // }),
      AiOutlineClear
    ),
  ],
];
// #endregion
